export enum ReceivedPaymentPaymentType {
    Check = 'Check',
    CreditCard = 'Credit Card',
    Other = 'Other',
    PayPal = 'PayPal',
}

export type ReceivedPayment = {
    /**
     * How much the payment was worth.
     * MUST be a positive number.
     */
    amount: number;
    description?: string;
    paymentId?: string;
    /**
     * How the customer transferred the money
     */
    paymentType: ReceivedPaymentPaymentType;
};

export type ReceivedPaymentSlice = {
    wasSaveSuccessful: boolean | undefined;
};

export const defaultReceivedPaymentSlice: ReceivedPaymentSlice = {
    wasSaveSuccessful: undefined,
};
